import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { CognitoAuthService } from '@auth/services/cognito-auth.service';
import { RdrAuthService } from '@app/auth/services/rdr-auth.service';
import { MyMonthlyStatsService } from '@app/pages/insights/services/my-monthly-stats.service';
import { FeatureToggleService, RdrFeature } from '@app/ui/services/feature-toggle.service';
import { Observable, concatMap, map, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class InsightsRedirectGuard {
  constructor(
    private router: Router,
    private cognitoAuthService: CognitoAuthService,
    private rdrAuthService: RdrAuthService,
    private featureToggleService: FeatureToggleService,
    private myMonthlyStatsService: MyMonthlyStatsService,
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.cognitoAuthService.hasCognitoSession().pipe(
      concatMap(() => this.rdrAuthService.getUser()),
      concatMap(() => {
        if (!this.featureToggleService.isFeatureEnabled(RdrFeature.monthly_stats)) {
          return of(true);
        }

        return this.myMonthlyStatsService
          .getAccess()
          .pipe(
            map((access) =>
              access.canView ? this.router.createUrlTree(['/team-dashboard']) : true,
            ),
          );
      }),
    );
  }
}
